import type { Rotina } from "~/types/pagesMenu";

export const nomesRotinasCadastro = {
  DADOS_LOGISTICOS: "Cadastro de Dados Logísticos",
  CODIGO_BARRAS: "Cadastro de Código de Barras",
  B231: "B231 — Pulmão gerando nova U.M.A",
  B232: "B232 — Pulmão com U.M.A pré-impressa",
  B233: "B233 — Pulmão do transitório",
  B234: "B234 — Picking → pulmão (mercadoria)",
  B235: "B235 — Picking → pulmão (U.M.A)",
  B237: "B237 — Picking → pulmão (U.M.A pré-impressa)",
  B241: "B241 — Vínculo ao Picking com Etiqueta",
  B242: "B242 — Vínculo ao Picking Sequenciado",
} as const;

export type RotinasCadastro = typeof nomesRotinasCadastro[keyof typeof nomesRotinasCadastro]

/**
 * Cadastro + família B23x (vínculo pulmão).
 *
 * B231–B237 usam o mesmo form Delphi
 * `PROC_MANIPULACAO_ENDERECO_MOVEL_COLETOR` com `vOrigemChamada` 0..5.
 * Tela web única: `/B23/<modo>` (B231, B232, …).
 *
 * Campo `nome` = item de menu do SIST_MAINFORM (CORE_ACESSO_USUARIO).
 */
const rotinasCadastro: Rotina[] = [
  {
    categoria: "Cadastro",
    label: nomesRotinasCadastro.DADOS_LOGISTICOS,
    nome: "mni_dados_logisticos_coletor",
    rotina: "PROC_CADASTRO_DADOS_LOGISTICOS_COLETOR",
    tela: "PROC_CADASTRO_DADOS_LOGISTICOS_COLETOR",
    disponivel: true,
  },
  {
    categoria: "Cadastro",
    label: nomesRotinasCadastro.CODIGO_BARRAS,
    nome: "B12CadastrodeCdigodeBarras1",
    rotina: "PROC_CADASTRO_DADOS_CODIGOBARRAS_COLETOR",
    tela: "PROC_CADASTRO_DADOS_CODIGOBARRAS_COLETOR",
    disponivel: true,
  },
  {
    categoria: "Cadastro",
    label: nomesRotinasCadastro.B241,
    nome: "mni_vinculo_mercadorias_enderecos_picking",
    rotina: "cadastro/vinculoPickingEtiqueta",
    tela: "B241",
    disponivel: true,
  },
  {
    categoria: "Cadastro",
    label: nomesRotinasCadastro.B242,
    nome: "mni_vinculo_mercadorias_enderecos_picking_sem_etiqueta",
    rotina: "cadastro/vinculoPickingEtiquetaRuaPredio",
    tela: "B242",
    disponivel: true,
  },
  {
    categoria: "Cadastro",
    label: nomesRotinasCadastro.B231,
    nome: "mni_VinculoMercadoriasEnderecoPulmaoColetor",
    rotina: "B23/B231",
    tela: "B231",
    disponivel: true,
  },
  {
    categoria: "Cadastro",
    label: nomesRotinasCadastro.B232,
    nome: "mni_VinculoEndPulmaoUMA",
    rotina: "B23/B232",
    tela: "B232",
    disponivel: true,
  },
  {
    categoria: "Cadastro",
    label: nomesRotinasCadastro.B233,
    nome: "mni_VinculoEndPulmaoTransitorio",
    rotina: "B23/B233",
    tela: "B233",
    disponivel: true,
  },
  {
    categoria: "Cadastro",
    label: nomesRotinasCadastro.B234,
    nome: "mni_VinculoEndPulmaoExcessoPicking",
    rotina: "B23/B234",
    tela: "B234",
    disponivel: true,
  },
  {
    categoria: "Cadastro",
    label: nomesRotinasCadastro.B235,
    nome: "mni_VinculoEndPulmaoExcessoPickingUMA",
    rotina: "B23/B235",
    tela: "B235",
    disponivel: true,
  },
  {
    categoria: "Cadastro",
    label: nomesRotinasCadastro.B237,
    nome: "mni_VinculoEndPulmaoExcessoPickingUMAPreImpressa",
    rotina: "B23/B237",
    tela: "B237",
    disponivel: true,
  },
];

export default rotinasCadastro;
